<template>
  <SogPage
    id="page"
    :title="_title"
  >
    <SogCard class="sog-card-without-title">
      <SogCardActions :is-toolbar="true">
        <SogCardActionButton
          :kind="SogButtonKind.Refresh"
          @click="onRefresh"
        />
        <SogCardActionButton :kind="SogButtonKind.Back" />
      </SogCardActions>
      <SogCardContent>
        <SogFlexColumn>
          <SogDatePicker
            v-model="_cutOfDay"
            placeholder="Berichtsdatum"
          />
          Wählen Sie ein Datei aus
          <SogUploader
            ref="_uploader"
            v-model="_array"
            :multiple="false"
            allowed-extensions=".xls,.xlsx"
          />
        </SogFlexColumn>
      </SogCardContent>
      <SogCardActions>
        <SogCardActionButton
          v-show="_array.length>0"
          mdi-icon="mdi-upload"
          @click="onImport"
        >
          importieren
        </SogCardActionButton>
      </SogCardActions>
    </SogCard>
    <SogCard>
      <SogGrid
        ref="_grid"
        :url="_url"
        :columns="_columns"
        width="auto"
        :on-command-click="onClick"
        @selected="onSelected"
      />
    </SogCard>
    <SogCard v-show="_errors">
      <SogCardTitle>Importresultat</SogCardTitle>
      <SogCardContent>
        <span style="white-space: pre-line">{{ _errors }}</span>
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, ref} from "vue";
import {onBeforeRouteUpdate, useRouter,} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogUploader from "@/shared/ui/SogUploader.vue";
import {TempFileInfo} from "@/shared/model/TempFileInfo";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {useAccountStore} from "@/stores/accountStore";
import notificationService from "@/shared/services/NotificationService";
import SogDatePicker from "@/shared/ui/SogDatePicker.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import apiLossAdjuster from "@/modules/LossAdjuster/api";
import SogGrid from "@/shared/ui/SogGrid.vue";
import {Api} from "@/shared/services/api";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {DateColumn, DateTimeColumn, DefaultColumn,} from "@/shared/ui/types/SogGridColumnDefinitions";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {IdType} from "@/shared/model/idType";
import apiFileUtils from "@/modules/FileUtils/api";
import apiFile from "@/shared/services/apiFile";


const _uploader = ref<InstanceType<typeof SogUploader> | null>(null)

const _title = ref("Bordereau hochladen")
const _spinner = useSpinner()
const _api = apiLossAdjuster
const _array = ref<TempFileInfo[]>([])
const _accountStore = useAccountStore()
const _router = useRouter()
const _cutOfDay = ref(new Date())
const _grid = ref<InstanceType<typeof SogGrid> | null>(null)
const _url = Api.baseUrl + '/LossAdjusterUploadList';
const _columns: ColumnModel[] = [
  /*
  { type: 'checkbox' },
*/
  {
    ...DefaultColumn,
    headerText: "",
    visible: true,
    commands: [
      {
        buttonOption: {
          cssClass: "e-flat",
          iconCss: "e-download e-icons",
          click: onClickDetails,
        },
      },
    ],
    textAlign: "Left",
    uid: "details",
    autoFit: true,
    width: "60px",

  },
  {...DefaultColumn, field: 'id', headerText: 'id', isPrimaryKey: true, visible: false},
  {...DefaultColumn, field: 'fileName', headerText: 'Datei'},
  {...DateColumn, field: 'cutOfDate', headerText: 'Datum'},
  {...DateTimeColumn, field: 'uploadDate', headerText: 'hochgeladen'},
  {...DefaultColumn, field: 'statusText', headerText: 'Status'},
  {...DefaultColumn, field: 'personName', headerText: ''},

]

const _errors = ref<string | undefined>();
const _buttonId = ref("");


async function p_init() {
  _spinner.show()
  try {
    if (_accountStore.person && !_accountStore.person.isLossAdjuster() && !_accountStore.isRoot) {
      _router.back()
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


async function onImport() {
  if (_array.value.length !== 1)
    return;
  _spinner.show()
  const res = await _api.upload(_array.value[0].id, _array.value[0].fileName, _cutOfDay.value);
  if (res) {
    notificationService.success("Datei " + _array.value[0].fileName + " wurde hochgeladen")
    _uploader.value?.clear()
    _grid.value?.refresh()
    _spinner.hide()
  }
}


function onSelected(data: any) {
  _errors.value = data?.errors
}

function onRefresh() {
  _grid.value?.refresh()
}

async function onClickDetails() {
  _buttonId.value = "download";
}

async function onClick(args: any) {
  //console.log(args.rowData)
  if (_buttonId.value === "download") {
    _spinner.show()
    const fileId = await apiLossAdjuster.initDownloadFile(args.rowData.id ?? "");
    if (fileId) await apiFile.downloadTempFile(fileId, args.rowData.fileName);
    _spinner.hide()

  }
}

</script>
<style scoped>
</style>
